import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { GrievanceNotificationService } from 'src/app/shared/services/API/hospital-document/grievance-notification.service';

@Component({
    selector: 'app-grievance-notification-pending-delete-modal',
    templateUrl: './grievance-notification-pending-delete-modal.component.html',
    styleUrls: ['./grievance-notification-pending-delete-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GrievanceNotificationPendingDeleteModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, 
    public dialog: MatDialog, 
    public matDialogRef: MatDialogRef<GrievanceNotificationPendingDeleteModalComponent>,
    private grievanceNotificationService: GrievanceNotificationService,
    private alertService: AlertService,
  ) { }

  public isLoading:boolean;  

  ngOnInit(): void {
    this.isLoading = false;
  }
  
  close(){
    this.matDialogRef.close({delete: false}); 
  }

  clickCancel(){
    this.matDialogRef.close({delete: false}); 
  }

  clickDelete() {
    this.isLoading = true;

    this.grievanceNotificationService.deleteGrievanceNotification(this.data.idGuideGrievanceNotification).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isLoading = false;
          return;
        }

        this.alertService.show('Sucesso', "Notificação de agravo excluida com sucesso!", AlertType.success);
        this.matDialogRef.close({delete: true}); 
      },
      error: (error) => {
        console.log(error)
        this.alertService.show('Erro inesperado', error, AlertType.error);
        this.isLoading = false;
      }
    });
  }
}